import React from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import useQueryCopierDetail from '../../../hooks/api/copier/useQueryCopierDetail'
import useQueryCopierBotRow from '../../../hooks/api/copier/useQueryCopierBotRow'
import {useSearchParams} from 'react-router-dom'
import CopierInfoContainer from '../../../features/page/copyTrading/copier/CopierInfoContainer'
import CopyTradingInfoContainer from '../../../features/page/copyTrading/copier/CopyTradingInfoContainer'
import CopyOrderHistoryContainer from '../../../features/page/copyTrading/copier/CopyOrderHistoryContainer'
import CopierInvoiceContainer from '../../../features/page/copyTrading/copier/CopierInvoiceContainer'
import RawJsonContainer from '../../../components/layout/RawJsonContainer'

interface IProps {
    className?: string
}

// 이 페이지는 admin 엔드포인트만 사용한다 — admin/copy/copier/:id 와 admin/copy/copiers(user_id 필터).
// 카피어/리더의 자산·포지션은 admin API가 제공하지 않아 섹션이 없다
// (백엔드 요청 내역: docs/admin-copy-api-requests.md).
const CopierDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const queryKeyId = searchParams.get('id')

    const {data} = useQueryCopierDetail(queryKeyId)
    const {data: botRow} = useQueryCopierBotRow(data?.user_id, data?.id, Boolean(data?.deleted_at))

    return (
        <PageLayout title={'Copier Detail'} className={`space-y-[30px] ${className}`}>
            <CopierInfoContainer data={data} />
            <CopyTradingInfoContainer data={data} botRow={botRow} />
            <CopierInvoiceContainer data={data} />
            <div className={'grid-cols-2 grid gap-[30px] lg:block lg:space-y-[30px]'}>
                <CopyOrderHistoryContainer title={'Copier History'} data={data?.orders} />
                <CopyOrderHistoryContainer title={'Leader History'} data={data?.leader_orders} />
            </div>
            <RawJsonContainer
                title={'admin/copy/copier/:id (Raw)'}
                data={data ? ({copierDetail: data, botRow} as any) : undefined}
            />
        </PageLayout>
    )
}

export default CopierDetailPage
